/**
 * Created by Daniela on 24/11/2016.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import {categoriasModuleName} from "../shared/data.service";
import {Categoria} from "../shared/categoria.model";
import {CategoriaNavigationService} from "../shared/categoria-navigation.service";
import {CategoriaApiService} from "../shared/categoria-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {newRouteFemale, editRoute} from "../../../shared/services/data.service";

@Component({
  template: require('./categoria-form.component.html'),
  styles: [require('./categoria-form.component.css')]
})
export class CategoriaFormComponent implements OnInit {
  moduleName: any = categoriasModuleName;
  formObject: any = new Categoria();
  actionTitle: string;
  submitted: boolean = false;
  btnSaveDisabled: boolean = false;

  form: FormGroup;
  categoria = new FormControl('', Validators.required);
  codigoTce = new FormControl('');
  ativo = new FormControl('');

  constructor(
    private _route: ActivatedRoute,
    private _categoriaNavigationService: CategoriaNavigationService,
    private _categoriaApiService: CategoriaApiService,
    private _utilService: UtilService,
    private _fb: FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      categoria: this.categoria,
      codigoTce: this.codigoTce
    });
  }

  ngOnInit() {
    this.testSession();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object:Categoria = this._utilService.cloneObject(this.formObject);

      if (this.formObject.id) {
        this.onEditCategoria(object);
      } else {
        this.onAddCategoria(object);
      }
    }
  }

  private onAddCategoria(object: Categoria) {
    this._categoriaApiService.onPost(object, this.onDone);
  }

  private onEditCategoria(object: Categoria) {
    this._categoriaApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }

      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response;
        this.setModelToForm();

      } else {
        this._utilService.swalMessageWarningCustom('Nenhuma categoria encontrada com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._categoriaApiService.onGetById(id, onDone);
  }

  private testSession() {
    let id = +this._route.snapshot.params['id'];
    if (id) {
      this.setEditNormal(id);
    } else {
      this.setNewNormal();
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: number) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRouteFemale;
    }
  }

  private setEditNormal(id: number) {
    this.getObject(id);
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
  }

  private setModelToForm() {

  }

  private goToList() {
    this._categoriaNavigationService.goToList();
  }

  private toLeaveHere() {
    this.goToList();
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/categorias/categoria-form/categoria-form.component.ts
 **/